import * as React from 'react';

// Components
import Container from '../Container';
import Paper from '../Paper';

// Style
import './FixedTopBar.css';

// Component
interface IProps {
  size: 'sm' | 'md' | 'lg' | 'xl' | 'fluid';
  horizontalPadded?: boolean;
  placement?: 'top' | 'bottom';
  children?: React.ReactNode | Array<React.ReactNode>;
}

const FixedTopBar = (props: IProps) => {
  return (
    <div className="FixedTopBar">
      <div
        className={`FixedTopBar__wrapper ${
          props.placement === 'bottom' ? 'FixedTopBar__wrapper--bottom' : ''
        } mui-fixed`}
      >
        {props.size === 'fluid' ? (
          <Paper className="FixedTopBar__Paper" square={true}>
            {props.children}
          </Paper>
        ) : (
          <Container
            size={props.size}
            horizontalPadded={props.horizontalPadded}
          >
            <Paper className="FixedTopBar__Paper">{props.children}</Paper>
          </Container>
        )}
      </div>
    </div>
  );
};

export default FixedTopBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/FixedTopBar.tsx